import { NgModule } from '@angular/core';;
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragulaModule } from 'ng2-dragula';
import { SharedModule } from 'app/shared/module/shared.module';
import { SearchModule } from 'app/shared/module/search/search.module';

// import { TagInputModule } from 'ngx-chips';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { DealReportComponent } from "./dealreport.component";

import { DealConversionByWonLostComponent } from '../dealreport/deal-conversion-by-won-lost/deal-conversion-by-won-lost.component';
import { DealConversionByStagesComponent } from '../dealreport/deal-conversion-by-stages/deal-conversion-by-stages.component';
import { DealActivitiesByEffortComponent } from '../dealreport/deal-activities-by-effort/deal-activities-by-effort.component';
import { CustomPipesModule } from 'app/shared/custom-pipes/custom-pipes.module';
// import { AddTaskComponent } from 'app/shared/module/add-task/add-task.component';
import { DealFunnelByStagesComponent } from '../dealreport/deal-funnel-by-stages/deal-funnel-by-stages.component';
import { ColorTwitterModule } from 'ngx-color/twitter'; 
import { ColorCircleModule } from 'ngx-color/circle'; 
import { NgSelectModule } from '@ng-select/ng-select';
import { DealboardInfoByStagesComponent } from '../dealreport/dealboard-info-by-stages/dealboard-info-by-stages.component';
import { ImDatePickerModule } from 'app/shared-modules/im-date-picker/im-date-picker.module';
import { CustomDirectiveModule } from 'app/shared/directive/directive.module';
import { DealReportByLostReasonsComponent } from '../dealreport/deal-report-by-lost-reasons/deal-report-by-lost-reasons.component';
import { DealReportByWinRateComponent } from '../dealreport/deal-report-by-win-rate/deal-report-by-win-rate.component';
import { ClosedDealsByCategoriesComponent } from '../dealreport/closed-deals-by-categories/closed-deals-by-categories.component';
import { SalesPipelineBySalesRepresentativesComponent } from '../dealreport/sales-pipeline-by-sales-representatives/sales-pipeline-by-sales-representatives.component';
import { SelectAgentModule } from 'app/shared-modules/select-agent/select-agent.module';
import { DealReportBySourcesComponent } from '../dealreport/deal-report-by-sources/deal-report-by-sources.component';
import { NgxMaskModule } from 'ngx-mask';
// import { ScreenComponent } from './pipeline-leaderboard/screen/screen.component';
import { LeaderboardReportsComponent } from '../leaderboard-reports/leaderboard-reports.component';
import { UserCreatedDealsComponent } from '../leaderboard-reports/user-created-deals/user-created-deals.component';
// import { LeadsourceComponent } from './leadsource/leadsource.component';
import { DealHealthComponent } from '../dealreport/deal-health/deal-health.component';
import { ClosedDealsByCarriersComponent } from '../dealreport/closed-deals-by-carriers/closed-deals-by-carriers.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DateRangeFilterModule } from 'app/shared-modules/date-range-filter/date-range-filter.module';
import { DealFunnelMovedComponent } from '../dealreport/deal-funnel-moved/deal-funnel-moved.component';
import { DealStagesComponent } from '../leaderboard-reports/deal-stages/deal-stages.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DealQuoteToCloseComponent } from '../dealreport/deal-quote-to-close/deal-quote-to-close.component';
import { PipelineLeaderboardModule } from 'app/shared-modules/pipeline-leaderboard/pipeline-leaderboard.module';
import { DealStageLifetimeComponent } from '../dealreport/deal-stage-lifetime/deal-stage-lifetime.component';
import { ModalQuoteToCloseComponent } from '../popups/modal-quote-to-close/modal-quote-to-close.component';
import { MonthlyDealsComponent } from './monthy-deals/monthly-deals.component';
import { BreadcrumbModule } from 'app/shared-modules/breadcrumbs/breadcrumb.module';
import { AgentGoalDetailModule } from 'app/shared-modules/agent-goal-detail/agent-goal-detail.module';
import { DealAnalyticsComponent } from './deal-analytics/deal-analytics.component';
import { DealFilteredComponent } from './deal-analytics-filtered/deal-analytics-filtered.component';
import { InViewportModule } from 'app/shared-modules/in-viewport';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AudioPlayerModule } from 'app/shared/module/audio-player/audio-player.module';
import { ShowAssigneeModule } from 'app/shared/show-assignee/show-assignee.module';






@NgModule({
  imports: [ 
    AgentGoalDetailModule,
    Ng2SearchPipeModule,
    PipelineLeaderboardModule,
    NgbModule,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDirectiveModule,
    // AmChartsModule,
    DragulaModule,
    BreadcrumbModule,
    SharedModule,
    CustomPipesModule,
    SearchModule,
    ColorTwitterModule,
    ColorCircleModule,
    ImDatePickerModule,
    NgSelectModule,
    SelectAgentModule,
    NgxMaskModule.forRoot(),
    DragDropModule,
    DateRangeFilterModule,
    InViewportModule,
    AudioPlayerModule,
    ShowAssigneeModule
    // AddDealcardModuleModule,
  ],
  declarations: [
    DealReportComponent,
    DealConversionByWonLostComponent,
    DealConversionByStagesComponent,
    DealActivitiesByEffortComponent,
    DealFunnelByStagesComponent,
    DealboardInfoByStagesComponent,
    DealReportByLostReasonsComponent,
    DealReportByWinRateComponent,
    ClosedDealsByCategoriesComponent,
    SalesPipelineBySalesRepresentativesComponent,
    DealReportBySourcesComponent,
    ClosedDealsByCarriersComponent,
    DealFunnelMovedComponent,
    DealStageLifetimeComponent,
    DealQuoteToCloseComponent,
    DealHealthComponent,
    ModalQuoteToCloseComponent,
    LeaderboardReportsComponent,
    UserCreatedDealsComponent,
    DealStagesComponent,
    MonthlyDealsComponent,
    DealAnalyticsComponent,
    DealFilteredComponent,
  ],
  exports: [
    DealReportComponent,
    DealConversionByWonLostComponent,
    DealConversionByStagesComponent,
    DealActivitiesByEffortComponent,
    DealFunnelByStagesComponent,
    DealboardInfoByStagesComponent,
    DealReportByLostReasonsComponent,
    DealReportByWinRateComponent,
    ClosedDealsByCategoriesComponent,
    SalesPipelineBySalesRepresentativesComponent,
    DealReportBySourcesComponent,
    ClosedDealsByCarriersComponent,
    DealFunnelMovedComponent,
    DealStageLifetimeComponent,
    DealQuoteToCloseComponent,
    DealHealthComponent,
    ModalQuoteToCloseComponent,
    LeaderboardReportsComponent,
    UserCreatedDealsComponent,
    DealStagesComponent,
    MonthlyDealsComponent,
    DealFilteredComponent
  ]
})
export class DealreportModule { }